import moment from 'moment'
import {Fragment, useEffect, useState} from 'react'
import {Badge, Button, Col, Container, OverlayTrigger, Row, Table, Tooltip} from 'react-bootstrap'
import {useNavigate, useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import {KTCard, KTIcon} from '../../../../../_metronic/helpers'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {
  changeLevelStatus,
  getDocumentAndDocsToApproveById,
  viewDocumentToApprove,
} from '../../../../services/documentos'
import {downloadFileS3, getFileId, getFileInPDF} from '../../../../services/files'
import {fetchMenuActionsByRole, fetchSubMenuByUrl} from '../../../../services/menu'
import {showMessage, showRejectionMessage} from '../../../../shared/Alerts'
import {getInfoRoute} from '../../../../shared/functions'
import {useGlobalOverlayLoading} from '../../../../shared/hooks/useGlobalOverlayLoading'
import {useAuth2} from '../../../authv2/Auth2Provider'
import {CustomTooltip} from '../../../generales_component/CustomTooltip'
import {GoBackButton} from '../../../generales_component/GoBackButton'
import OverlayLoading from '../../../generales_component/OverlayLoading'
import {PdfLoadingSpinner} from '../../../generales_component/PdfLoadingSpinner'
import {DetalleNivelModal} from './detalle-nivel-modal/DetalleNivelModal'
import {DocumentLoadDetailContext} from './DocumentLoadDetailContext'
import {ShowFile2Modal} from './show-file2-modal/ShowFile2Modal'

const documentosBreadcrumbs = [
  {
    title: 'Aprobacion de documentos - Detalle',
    path: '/seguimiento/aprobacion-any',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DocumentDetailAprobacionAny = () => {
  const navigate = useNavigate()
  const {id} = useParams()
  const {userData, selectedRole} = useAuth2()
  const {setGlobalOverlayLoading} = useGlobalOverlayLoading()
  const [loading, setLoading] = useState(true)
  const [permissions, setPermissions] = useState<string[]>([])

  const [documentoArray, setDocumentoArray] = useState<Record<string, any>[]>([])
  const [showFile2Modal, setShowFile2Modal] = useState(false)
  const [loadingNewPdf, setLoadingNewPdf] = useState(false)
  const [selectedPlantillaId, setSelectedPlantillaId] = useState('')
  const [data, setData] = useState<any>()

  const [levelModalStatus, setLevelModalStatus] = useState(false)
  const [levelModalData, setLevelModalData] = useState<any>(null)
  const [loadingApprove, setLoadingApprove] = useState(false)

  useEffect(() => {
    const fetchPermissions = async () => {
      const response = await fetchMenuActionsByRole(selectedRole)
      if (response.success) {
        const infoRoute = getInfoRoute(window.location)
        const currentPath = infoRoute?.parentPath + '/' + infoRoute?.path
        const subMenuResponse = await fetchSubMenuByUrl(currentPath)
        if (subMenuResponse.success) {
          const subMenuId = subMenuResponse.data.id_hijo
          const permissionsForSubMenu =
            response.data.find((item: any) => item.subMenuId === subMenuId)?.acciones || []
          setPermissions(permissionsForSubMenu)
        }
      }
    }

    fetchPermissions()
  }, [selectedRole])

  const goBack = () => {
    navigate('/seguimiento/aprobacion-any')
  }

  useEffect(() => {
    if (id) {
      getDocument(id)
    }
  }, [])

  const getDocument = async (id: string) => {
    try {
      const response = await getDocumentAndDocsToApproveById(id)
      if (response.success) {
        setData(response.data)
      } else {
        showMessage('error', 'Hubo un error', response.message)
      }
    } catch (error) {
      showMessage('error', 'Hubo un error', (error as Error).message)
    } finally {
      setLoading(false)
    }
  }

  const handleDocumentQuickViewModal = async (idPkg: string, file: any) => {
    setLoadingNewPdf(true)

    const filedat = await getFileId(file._id)
    const fileInPdf = await getFileInPDF(filedat.data.keyname)
    setDocumentoArray([
      {
        uri: fileInPdf.data,
        fileType: 'pdf',
        fileName: filedat.data.filename,
        keyName: filedat.data.keyname,
      },
    ])

    await viewDocumentToApprove(idPkg, file._id)
    await getDocument(idPkg)
    setShowFile2Modal(true)
    setLoadingNewPdf(false)
  }

  const handleDownload = async (id: string, idFile: string, keyname: string, filename: string) => {
    console.log(keyname)
    console.log(filename)
    const partes = filename.split('.')
    const extension = partes[partes.length - 1]

    downloadFileS3(keyname, extension)
      .then(async (response) => {
        if (response.success) {
          await viewDocumentToApprove(id, idFile)
          await getDocument(id)

          const link = document.createElement('a')
          link.href = response.data
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          showMessage('success', '¡Buen trabajo!', response.message)
        } else {
          showMessage('error', 'Hubo un error', response.error)
        }
      })
      .catch((error) => {
        showMessage('error', 'Hubo un error', error.message)
      })
  }

  const handleLevelAction = (action: 'approve' | 'deny', idFile: string, idLevel: string) => {
    const actions = {
      deny: 'rechazar',
      approve: 'aprobar',
    }

    if (action === 'deny') {
      showRejectionMessage().then(async (result) => {
        if (result.isConfirmed) {
          setGlobalOverlayLoading(true)
          const resp = await changeLevelStatus({
            idFile,
            idLevel,
            status: action,
            idDoc: id,
            motivo: result.value,
          })

          if (resp.success) {
            showMessage('success', '¡Buen trabajo!', resp.message)
            await getDocument(id as string)
          } else {
            showMessage('error', 'Hubo un error', resp.message)
          }
          setGlobalOverlayLoading(false)
          setLoadingApprove(false)
        }
      })
      return
    }

    Swal.fire({
      title: `¿Está seguro que desea ${actions[action]} este nivel?`,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setGlobalOverlayLoading(true)
        const resp = await changeLevelStatus({
          idFile,
          idLevel,
          status: action,
          idDoc: id,
        })

        if (resp.success) {
          showMessage('success', '¡Buen trabajo!', resp.message)
          getDocument(id as string)
        } else {
          showMessage('error', 'Hubo un error', resp.message)
        }
        setGlobalOverlayLoading(false)
      }
    })
  }

  const handleNextLevelMyAuthDocsToApprove = async (docsToAppove: any[]) => {
    setGlobalOverlayLoading(true)
    const responses: boolean[] = []

    for (const doc of docsToAppove) {
      const response = await changeLevelStatus({
        status: doc.status,
        idFile: doc.idFile,
        idLevel: doc.idLevel,
        idDoc: id,
      })

      responses.push(response.success)
    }

    setGlobalOverlayLoading(false)

    const allSuccess = responses.every((response) => response)

    if (allSuccess) {
      showMessage('success', '¡Buen trabajo!', '')
      getDocument(id as string)
    } else {
      showMessage('error', 'Hubo un error', '')
    }
  }

  const docsToAppove =
    data?.idFiles
      ?.map((file: any) => {
        if (file.isSendByLevel === true) {
          return null
        }

        if (file.currentLevel == null) {
          return null
        }

        if (!(file?.views ?? []).includes(userData?.userId)) {
          return null
        }

        const level = file.detalle_niveles?.find((level: any) => level._id === file.currentLevel)

        if (level == null) {
          return null
        }

        if (!level.autorizado === true || level.detalle.estado === 'rechazado') {
          return null
        }

        if (
          level.detalle.aprobaciones_hechas?.map((d: any) => d.idUser)?.includes(userData?.userId)
        ) {
          return null
        }

        return {
          idDoc: id,
          idFile: data._id,
          idLevel: level._id,
          status: 'approve',
        }
      })
      ?.filter((x: any) => x != null) ?? []

  const handleOpenLevelModal = (file: any) => {
    setLevelModalData(file)
    setLevelModalStatus(true)
  }

  const canAprove = permissions.includes('Aprobar documento')
  const canDeny = permissions.includes('Rechazar documento')
  const canDownload = permissions.includes('Descargar documento')
  const canView = permissions.includes('Ver documento')
  const canViewDetail = permissions.includes('Detalle documento')

  return (
    <DocumentLoadDetailContext.Provider
      value={{
        documentoArray,
        setDocumentoArray,
        showFile2Modal,
        setShowFile2Modal,
        loadingNewPdf,
        setLoadingNewPdf,
        selectedPlantillaId,
        setSelectedPlantillaId,
        data,
      }}
    >
      <PageTitle breadcrumbs={documentosBreadcrumbs}>Detalle de Paquete</PageTitle>
      <GoBackButton goBack={goBack} />
      <KTCard>
        {loading ? (
          <PdfLoadingSpinner />
        ) : (
          <div className='pt-12 pb-6'>
            <Container>
              <Row className='mb-5'>
                <Col sm>
                  <div className='d-flex justify-content-between'>
                    <div>
                      <h3>{data?.nombre}</h3>
                      {canAprove && docsToAppove.length > 0 && (
                        <Button onClick={() => handleNextLevelMyAuthDocsToApprove(docsToAppove)}>
                          Aprobar todos los niveles correspondientes
                        </Button>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col sm>
                  <Table className='table align-middle table-row-bordered fs-6'>
                    <thead>
                      <tr className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-primary text-white'>
                        <th className='p-3'>Documentos</th>
                        <th className='p-3'>Tipo</th>
                        <th className='p-3'>Objetivo</th>
                        <th className='text-center'>Niveles aprobados</th>
                        <th className='p-3'>Detalle grupo</th>
                        <th className='text-end' style={{paddingRight: '5px'}}>
                          Opciones
                        </th>
                      </tr>
                    </thead>
                    <tbody className='text-gray-600 fw-bold'>
                      {data?.idFiles?.map((file: any, index: any) => {
                        const hasLevels =
                          file.detalle_niveles != null && file.detalle_niveles.length > 0
                        const pendingLevels = file.detalle_niveles?.filter(
                          (x: any) =>
                            ['pendiente', 'rechazado'].includes(x.detalle.estado) ||
                            x.detalle.estado == null
                        )

                        const canApproveAndDeny = (file?.views ?? []).includes(userData?.userId)

                        const currentLevel = pendingLevels?.find(
                          (x: any) => x._id === file.currentLevel
                        )

                        const aprobacionesHechas =
                          currentLevel?.detalle?.aprobaciones_hechas?.length ?? 0
                        const cantidadAprobaciones =
                          currentLevel?.detalle?.cantidadaprobaciones ?? 0

                        const imAuthorized =
                          currentLevel?.autorizado === true &&
                          aprobacionesHechas < cantidadAprobaciones &&
                          !currentLevel?.detalle?.aprobaciones_hechas
                            ?.map((d: any) => d.idUser)
                            ?.includes(userData?.userId) &&
                          (currentLevel?.detalle?.estado == null ||
                            currentLevel?.detalle?.estado === 'pendiente') &&
                          file.isSendByLevel !== true

                        const nivelesAprobados =
                          file.detalle_niveles?.filter((x: any) => x.detalle.estado === 'aprobado')
                            ?.length ?? 0

                        const currentLevelNumber =
                          nivelesAprobados + 1 > (file.detalle_niveles?.length ?? 0)
                            ? nivelesAprobados
                            : nivelesAprobados + 1

                        return (
                          <Fragment key={file._id}>
                            {['Configurado', 'CPD'].includes(file.typeSelected) && (
                              <tr>
                                <td className='text-start fw-bold p-3'>
                                  <Badge bg='success-active' className='me-2'>
                                    {index + 1}
                                  </Badge>
                                  {file.name}
                                </td>
                                <td className='text-start fw-bold'>{file.type}</td>
                                <td className='text-start fw-bold'>{file.typeSelected}</td>
                                <td
                                  className={`text-start ${
                                    imAuthorized ? 'd-flex justify-content-between' : ''
                                  }`}
                                >
                                  <CustomTooltip
                                    popperConfig={{
                                      modifiers: [{name: 'offset', options: {offset: [50, 50]}}],
                                    }}
                                    placement='top-end'
                                    variant='light'
                                    className='btn-not-hover bg-transparent w-100 h-100 text-black text-hover-black'
                                    label={
                                      <>
                                        <span>
                                          {hasLevels
                                            ? `${nivelesAprobados} de ${file.detalle_niveles?.length}`
                                            : 'Sin nivel'}
                                        </span>
                                        {hasLevels && imAuthorized && (
                                          <div>
                                            {canAprove &&
                                              (!canApproveAndDeny ? (
                                                <OverlayTrigger
                                                  placement='bottom-start'
                                                  popperConfig={{
                                                    modifiers: [
                                                      {
                                                        name: 'offset',
                                                        options: {offset: [-80, 80]},
                                                      },
                                                    ],
                                                  }}
                                                  overlay={
                                                    <Tooltip id='disabled-tooltip'>
                                                      Este boton está desactivado porque el
                                                      documento no se ha visualizado o descargado.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <span>
                                                    <button
                                                      title='Aprobar documento'
                                                      className='btn btn-icon btn-sm'
                                                      disabled
                                                    >
                                                      <KTIcon
                                                        iconName='like'
                                                        className='fs-3 text-success'
                                                      />
                                                    </button>
                                                  </span>
                                                </OverlayTrigger>
                                              ) : (
                                                <button
                                                  title='Aprobar documento'
                                                  className='btn btn-icon btn-sm'
                                                  disabled={loadingApprove}
                                                  onClick={() =>
                                                    handleLevelAction(
                                                      'approve',
                                                      file._id,
                                                      file.currentLevel
                                                    )
                                                  }
                                                >
                                                  <KTIcon
                                                    iconName='like'
                                                    className='fs-3 text-success'
                                                  />
                                                </button>
                                              ))}

                                            {canDeny &&
                                              (!canApproveAndDeny ? (
                                                <OverlayTrigger
                                                  placement='bottom-start'
                                                  popperConfig={{
                                                    modifiers: [
                                                      {
                                                        name: 'offset',
                                                        options: {offset: [80, 80]},
                                                      },
                                                    ],
                                                  }}
                                                  overlay={
                                                    <Tooltip id='disabled-tooltip'>
                                                      Este boton está desactivado porque el
                                                      documento no se ha visualizado o descargado.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <span>
                                                    <button
                                                      title='Rechazar documento'
                                                      className='btn btn-icon btn-sm'
                                                      disabled
                                                    >
                                                      <KTIcon
                                                        iconName='dislike'
                                                        className='fs-3 text-danger'
                                                      />
                                                    </button>
                                                  </span>
                                                </OverlayTrigger>
                                              ) : (
                                                <button
                                                  title='Rechazar documento'
                                                  className='btn btn-icon btn-sm'
                                                  disabled={loadingApprove}
                                                  onClick={() =>
                                                    handleLevelAction(
                                                      'deny',
                                                      file._id,
                                                      file.currentLevel
                                                    )
                                                  }
                                                >
                                                  <KTIcon
                                                    iconName='dislike'
                                                    className='fs-3 text-danger'
                                                  />
                                                </button>
                                              ))}
                                          </div>
                                        )}
                                      </>
                                    }
                                  >
                                    {file.historial_niveles != null
                                      ? file.historial_niveles.length > 0
                                        ? file.historial_niveles.map(
                                            (historial: any, index: number) => (
                                              <div
                                                key={index}
                                                className='p-3 border-bottom border-black d-flex flex-column gap-1 align-items-start'
                                                style={{fontSize: '0.8rem'}}
                                              >
                                                <p className='mb-0 text-start'>
                                                  Nivel{' '}
                                                  {file.detalle_niveles.findIndex(
                                                    (n: any) => n._id === historial.idLevel
                                                  ) + 1}
                                                </p>
                                                <p
                                                  className={`mb-0 text-start ${
                                                    historial.estado === 'rechazado'
                                                      ? 'text-danger'
                                                      : 'text-success'
                                                  }`}
                                                >
                                                  Estado: {historial.estado}
                                                </p>
                                                <p className='mb-0 text-start'>
                                                  {historial.estado === 'rechazado'
                                                    ? 'Rechazado por: '
                                                    : 'Aprobado por: '}{' '}
                                                  {historial.username}
                                                </p>
                                                <p className='mb-0 text-start'>
                                                  Fecha:{' '}
                                                  {moment(historial.fecha).format(
                                                    'DD/MM/YYYY H:mm'
                                                  )}
                                                </p>
                                                {historial.motivo != null && (
                                                  <p className='mb-0 text-start'>
                                                    {historial.motivo}
                                                  </p>
                                                )}
                                              </div>
                                            )
                                          )
                                        : 'Sin historial'
                                      : 'Sin historial'}
                                  </CustomTooltip>
                                </td>
                                <td className='text-start fw-bold'>
                                  {hasLevels ? (
                                    <CustomTooltip
                                      variant='light'
                                      className='btn-not-hover bg-transparent w-100 h-100 text-black text-hover-black'
                                      label='Ver'
                                      icon='eye'
                                      overlay={false}
                                      onClick={() => handleOpenLevelModal(file)}
                                    />
                                  ) : (
                                    'Ninguno'
                                  )}
                                </td>
                                <td className='text-end'>
                                  {canView && (
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      title='Visualización rápida'
                                      onClick={() => handleDocumentQuickViewModal(data._id, file)}
                                    >
                                      <KTIcon iconName='eye' className='fs-3' />
                                    </button>
                                  )}

                                  {canDownload && (
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      title={
                                        canDownload
                                          ? 'Descargar Documentos'
                                          : 'No tienes permiso para descargar'
                                      }
                                      disabled={!canDownload}
                                      onClick={() =>
                                        handleDownload(
                                          data._id,
                                          file._id,
                                          file.keyname,
                                          file.filename
                                        )
                                      }
                                    >
                                      <KTIcon iconName='cloud-download' className='fs-3' />
                                    </button>
                                  )}

                                  {/*canViewDetail && file.typeSelected === 'Configurado' && (
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                      title='Detalle del documento'
                                      onClick={() => handleDocumentDetailModal(file)}
                                    >
                                      <KTIcon iconName='information' className='fs-3' />
                                    </button>
                                  )*/}
                                </td>
                              </tr>
                            )}
                          </Fragment>
                        )
                      })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </KTCard>
      {loadingNewPdf && <OverlayLoading />}
      <ShowFile2Modal />
      {levelModalStatus && (
        <DetalleNivelModal
          grupos={levelModalData.detalle_niveles}
          filename={levelModalData.name}
          historial={levelModalData.historial_niveles}
          closeModal={() => setLevelModalStatus(false)}
        />
      )}
    </DocumentLoadDetailContext.Provider>
  )
}

export {DocumentDetailAprobacionAny}
